<template>
  <kambly-form inline-template>
    <div class="form">
      <form class="form__form" method="POST"
            v-bind:action="endpoint"
            ref="form">

        <form-field name="email" type="hidden" :value="contestantEmail"></form-field>

        <div class="form__row">
          <div class="row">
            <div class="col-md-12">
              <form-field :label="content.formLabels.street" name="street"
                          type="text"
                          validation="required"></form-field>
            </div>
          </div>
        </div>
        <div class="form__row">
          <div class="row">
            <div class="col-md-4">
              <form-field :label="content.formLabels.zip"
                          name="postalcode"
                          type="text"
                          :validation="'required|plz-' + contestCountry">
              </form-field>
            </div>
            <div class="col-md-8">
              <form-field :label="content.formLabels.city" name="city" type="text"
                          validation="required"></form-field>
            </div>
          </div>
        </div>

        <!-- Shipping Address -->
        <div class="form__row">
          <div class="row">
            <div class="col-md-6">
              <form-field :label="content.formLabels.shippingLastname" name="shipping-name"
                          type="text"
                          validation="required"></form-field>
            </div>
            <div class="col-md-6">
              <form-field :label="content.formLabels.shippingName" name="shipping-firstname"
                          type="text" validation="required"></form-field>
            </div>
          </div>
        </div>
        <div class="form__row">
          <div class="row">
            <div class="col-md-12">
              <form-field :label="content.formLabels.shippingStreet" name="shipping-street"
                          type="text"
                          validation="required"></form-field>
            </div>
          </div>
        </div>
        <div class="form__row">
          <div class="row">
            <div class="col-md-4">
              <form-field :label="content.formLabels.shippingZip"
                          name="shipping-postalcode"
                          type="text"
                          :validation="'required|plz-' + contestCountry">
              </form-field>
            </div>
            <div class="col-md-8">
              <form-field :label="content.formLabels.shippingCity" name="shipping-city"
                          type="text"
                          validation="required"></form-field>
            </div>
          </div>
        </div>
        <div class="form__row">
          <div class="row">
            <div class="col-md-12">
              <form-textarea :label="content.formLabels.shippingMessage" name="shipping-message"
                              type="textarea"></form-textarea>
            </div>
          </div>
        </div>

        <!-- Submit -->
        <div class="form__row">
          <div class="row">
            <div class="col-12 d-md-flex justify-content-end">
              <div class="form__submit">
                <div class="button button--primary" @click.exact="resetAll" @click.prevent="submitForm">{{ content.abortLabel }}</div>
              </div>
              <div class="form__submit">
                <button class="button button--secondary" :class="{'button--loading': loading}" type="submit" :disabled="loading"
                        @click.prevent="submitForm">{{ content.continueLabel}}</button>
              </div>
            </div>
          </div>
        </div>

      </form>
    </div>
  </kambly-form>
</template>

<script>
import { mapGetters } from 'vuex'
import FormTextarea from "@/components/FormTextArea";
export default {
  components: {FormTextarea},
  computed: {
    ...mapGetters([
      'content'
    ])
  }
}
</script>